/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable no-underscore-dangle */
/* eslint-disable import/no-cycle */
import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { define, ui, s } from '@owenscorning/pcb.alpha';
import { useEffect, useState } from 'react';

import { mdms } from '../../../../../api';
import Modal from '../../../../Modal';
import { BasicContent } from '../../../../OC/PageBuilder/BasicContent';
import { H3, H4 } from '../../../../OC/oc-h';
import { getParams } from '../../../../helpers/params';
import { connectLocation } from '../../../../location/LocationConnectors';
import CTA from '../../CTA';

const MainHeading = styled(H3)`
  margin-bottom: 32px;
`;

const ModalHeading = styled(H3)`
  margin-bottom: 16px;
`;

const zoomWrapperStyles = css`
  align-items: center;
  cursor: pointer;
  display: inline-flex;
  height: 220px;
  position: relative;
  width: 220px;

  @media (max-width: 767px) {
    height: 105px;
    width: 105px;
  }

  img {
    width: 100%;
  }

  .fa {
    background: rgba(0, 0, 0, 0.5);
    border-right: 1px white solid;
    border-top: 1px white solid;
    bottom: 0;
    color: #fff;
    font-size: 24px;
    left: 0;
    padding: 12px;
    position: absolute;
  }
`;

const ZoomWrapper = ({ children, onClick }) => (
  <div css={zoomWrapperStyles} onClick={onClick}>
    <span className="fa fa-search-plus" />
    {children}
  </div>
);

const ImageContainer = styled.div`
  column-gap: 16px;
  display: inline-flex;
  margin-bottom: 16px;
  margin-top: 0px;
  width: 100%;
`;

const mapStyleBoard = sbData => {
  const shingleColorData = sbData?.contents?.[0]?.shingleColor?.color?.__data?.data?.shingle_colors?.[0];
  const pairingTitle = `${sbData?.contents?.[0]?.colorName} & ${shingleColorData?.name}`;
  return {
    shingleColorUid: shingleColorData?.uid,
    route: sbData?.route,
    smallImageUrl: sbData.contents?.[0]?.heroImage?.mobile?.file,
    fullImageUrl: sbData.contents?.[0]?.heroImage?.desktop?.file,
    shingleColorName: shingleColorData?.name,
    title: pairingTitle,
  };
};

const StyleBoardsForColor = connectLocation(
  ({ name, mainHeading, bodyHeading, bodyCopy, locale, cta, modalCtaText }) => {
    const [styleBoardsData, setStyleBoardsData] = useState(null);
    const [currentModalStyleBoard, setCurrentModalStyleBoard] = useState(null);

    useEffect(() => {
      mdms
        .get(`/api/v2/cms/sites/www.owenscorning.com/data?dataset=color_pairing&language=${locale?.code}&type=ItemList`)
        .then(response => response.json())
        .then(responseJson => {
          setStyleBoardsData(responseJson?.data);
        });
    }, []);

    const currentShingleColorUid = getParams()['shingle-color'];
    const mappedStyleBoards = styleBoardsData?.map(sb => mapStyleBoard(sb));
    const foundStyleBoards = mappedStyleBoards?.filter(sb => sb?.shingleColorUid === currentShingleColorUid);

    if (!foundStyleBoards?.length) return null;

    const shingleColorName = foundStyleBoards[0]?.shingleColorName;
    return (
      <>
        {mainHeading && (
          <MainHeading font="body">{mainHeading?.replace('%n', `${name} ${shingleColorName}`)}</MainHeading>
        )}
        {bodyHeading && <H4 font="body">{bodyHeading}</H4>}
        {bodyCopy && <BasicContent bodyCopy={bodyCopy} />}
        <ImageContainer>
          {foundStyleBoards?.map(sb => (
            <ZoomWrapper
              onClick={() => {
                setCurrentModalStyleBoard(sb);
              }}
            >
              <img src={sb?.smallImageUrl} alt={sb?.title} />
            </ZoomWrapper>
          ))}
        </ImageContainer>
        {cta && <CTA url={cta?.url} text={cta?.text} color={cta?.color} />}
        <Modal
          open={currentModalStyleBoard}
          onClose={() => {
            setCurrentModalStyleBoard(null);
          }}
          className="no-borders gallery-modal"
        >
          <img src={currentModalStyleBoard?.fullImageUrl} alt={currentModalStyleBoard?.title} />
          <p>Shingle Style Board</p>
          <ModalHeading>{currentModalStyleBoard?.title}</ModalHeading>
          <CTA url={`/${locale?.code}${currentModalStyleBoard?.route}`} text={modalCtaText} color="white" />
        </Modal>
      </>
    );
  }
);

export default define`Style Boards for Color`('0.0.1')({
  thumbnail: ui`Modules/Page/Thumbnails/Modules/Page/Thumbnails/StyleBoardsForColor`,
  view: ({ Board, value }) => (
    <StyleBoardsForColor name={Board?.build?.name} pageSlug={Board?.build?.slug} {...value} />
  ),
  edit: ui`Form`.of({
    mainHeading: ui`Text`({ label: 'Heading', default: 'Explore More %n' }),
    [s._]: ui`Tip`.of('Use "%n" to inject the name of the current shingle and color.'),
    bodyHeading: ui`Text`({ label: 'Body Heading', default: 'Get Inspired With Style Boards' }),
    bodyCopy: ui`Text/Rich`({ label: 'Body Copy' }),
    cta: ui`CTA`({
      label: 'Bottom CTA',
      default: {
        text: 'View All Style Boards',
        url: '/en-us/roofing/design-inspire/shingles-colors-style-boards',
        color: 'white',
      },
    }),
    modalCtaText: ui`Text`({ label: 'Modal CTA Text', default: 'View Pairing Details' }),
  }),
});
